import { useEffect } from "react";
import s from "./activation.module.css";
import { useActivation } from "./ActivationContext";
import { useTrainingMode } from "../training/TrainingModeContext";

function navIdFromTarget(target) {
  const match = String(target || "").match(/data-act-nav="([^"]+)"/);
  return match?.[1] || null;
}

export function useNavHighlight(navId) {
  const {
    visible,
    currentStep,
    currentSubstep,
    completed,
    skipped,
  } = useActivation();
  const {
    active: trainingActive,
    currentLesson,
    currentTrainingSubstep,
    completed: trainingCompleted,
    skipped: trainingSkipped,
  } = useTrainingMode();

  if (trainingActive && currentLesson && currentTrainingSubstep?.kind === "nav") {
    if (
      trainingCompleted.includes(currentLesson.id) ||
      trainingSkipped.includes(currentLesson.id)
    ) {
      return false;
    }
    return navIdFromTarget(currentTrainingSubstep.target) === navId;
  }

  if (!visible || !currentStep || currentSubstep?.kind !== "nav") {
    return false;
  }
  if (completed.includes(currentStep.id) || skipped.includes(currentStep.id)) {
    return false;
  }
  return navIdFromTarget(currentSubstep.target) === navId;
}

/**
 * Wraps a nav link without touching its className (NavLink uses a function there).
 */
export default function ActivationNavTarget({ navId, children }) {
  const highlight = useNavHighlight(navId);

  useEffect(() => {
    if (!highlight) return undefined;
    const t = window.setTimeout(() => {
      document
        .querySelector(`[data-act-nav="${navId}"][data-act-active="1"]`)
        ?.scrollIntoView?.({ behavior: "smooth", block: "nearest" });
    }, 120);
    return () => window.clearTimeout(t);
  }, [highlight, navId]);

  return (
    <span
      className={s.actNavWrap}
      data-act-nav={navId}
      data-act-active={highlight ? "1" : undefined}
    >
      {children}
    </span>
  );
}
